import { ActionIcon, Button, ButtonProps } from '@mantine/core';

import classes from './nli-button.module.css';
import { NliButtonProps, NliIconButtonProps } from './props';

function NliButton({ children, ...props }: NliButtonProps) {
    return <Button
        {...(props as ButtonProps)}
        role="button"
    >
        {children}
    </Button>;
}

function NliSmallBlueButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.smalleBlueButton}
        color="nli-liberty"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliWideButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.wideButton}
        fullWidth
        color="nli-liberty"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliWideOutlinedButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliWideOutlinedButton}
        loaderProps={{ color: 'nli-liberty' }}
        variant="default"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliSmallOutlinedButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliSmallOutlinedButton}
        loaderProps={{ color: 'nli-liberty' }}
        variant="default"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliOutlinedButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliOutlinedButton}
        loaderProps={{ color: 'nli-liberty' }}
        variant="default"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliDarkOutlinedButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliDarkOutlinedButton}
        classNames={{ root: classes.root }}
        loaderProps={{ color: 'nli-liberty' }}
        variant="default"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliAiButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliAiButton}
        loaderProps={{ color: 'nli-liberty' }}
        variant="filled"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliGradientButton({ children, ...props }: NliButtonProps) {
    return <NliButton
        className={classes.nliGradientButton}
        loaderProps={{ color: 'nli-liberty' }}
        variant="default"
        {...props}
    >
        {children}
    </NliButton>;
}

function NliIconButton({ children, ...props }: NliIconButtonProps) {
    return <ActionIcon
        className={classes.nliIconButton}
        {...props}
    >
        {children}
    </ActionIcon>;
}

function NliIconSmallOutlinedButton({ children, ...props }: NliIconButtonProps) {
    return <NliIconButton
        className={classes.nliIconSmallOutlinedButton}
        variant="default"
        {...props}
    >
        {children}
    </NliIconButton>;
}

function NliIconOutlinedButton({ children, ...props }: NliIconButtonProps) {
    return <NliIconButton
        className={classes.nliIconOutlinedButton}
        variant="default"
        {...props}
    >
        {children}
    </NliIconButton>;
}

function NliIconDarkOutlinedButton({ children, ...props }: NliIconButtonProps) {
    return <NliIconButton
        className={classes.nliIconDarkOutlinedButton}
        variant="default"
        {...props}
    >
        {children}
    </NliIconButton>;
}

function NliIconGradientButton({ children, ...props }: NliIconButtonProps) {
    return <NliIconButton
        className={classes.nliIconGradientButton}
        variant="default"
        {...props}
    >
        {children}
    </NliIconButton>;
}

export {
    NliButton,
    NliDarkOutlinedButton,
    NliGradientButton,
    NliIconButton,
    NliIconDarkOutlinedButton,
    NliIconGradientButton,
    NliIconOutlinedButton,
    NliIconSmallOutlinedButton,
    NliOutlinedButton,
    NliSmallBlueButton,
    NliSmallOutlinedButton,
    NliWideButton,
    NliWideOutlinedButton,
    NliAiButton
};
